import { useConnection } from "@/components/features/items/edit/_shared/ui/components/main/questions/connection/hooks";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomPlanConnection = () => {
	const { viewModel, onSetViewModel, queryData } = useProductRoomFormModelContext();
	const { availablePlanIDs } = viewModel;
	const { planNameAndIDOptions } = queryData.connection;

	return useConnection({
		availableItemIDs: availablePlanIDs,
		onSetViewModel,
		keyOfValue: "availablePlanIDs",
		nameAndIDOptions: planNameAndIDOptions,
	});
};
